import { render, staticRenderFns } from "./addIssue.vue?vue&type=template&id=7d35c09c&scoped=true"
import script from "./addIssue.vue?vue&type=script&lang=js"
export * from "./addIssue.vue?vue&type=script&lang=js"
import style0 from "./addIssue.vue?vue&type=style&index=0&id=7d35c09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d35c09c",
  null
  
)

export default component.exports